module.exports = __webpack_public_path__ + "static/media/copy-code.4edaca5d.mp4";